import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Request from './Request';

const Requests = ({ specialRequests }) => {
  const { t } = useTranslation('workOrdersTable');

  return (
    <>
      <Typography variant="subtitle2" color="textPrimary">
        {t('card.hiddenContent.requestsTitle')}
      </Typography>

      {specialRequests?.map((request, i) => (
        <Request key={i} text={request} />
      ))}
    </>
  );
};

export default Requests;
